import BaseService from './base.service';

class MyService extends BaseService {
  
  async getDefalutFormulaHistory() {
    const response = await this.get('my/formula-folder/default/formula');
    return response.data;
  }

  async getFormula(formulaFolderSeq, paginator) {
    const response = await this.get(`my/formula-folder/${formulaFolderSeq}/formula`, paginator);
    return response.data;
  }

  async moveFormula(targetFolder, queries) {
    const response = await this.put(`my/formula-folder/${targetFolder.seq}/formula`, queries);
    return response.data;
  }

  async deleteFormula(queries) {
    const response = await this.delete(`my/formula-folder`, queries);
    return response.data;
  }

  async getFormulaFolder() {
    const response = await this.get(`my/formula-folder`);
    return response.data;
  }

  async addFolder(folder) {
    const response = await this.post(`my/formula-folder`, folder);
    return response.data;
  }

  async updateFolder(folder) {
    const response = await this.put(`my/formula-folder/${folder.seq}`, folder);
    return response.data;
  }

  async deleteFolder(folder) {
    const response = await this.delete(`my/formula-folder/${folder.seq}`);
    return response.data;
  }

  async getBookmark(paginator) {
    const response = await this.get(`my/bookmark`, paginator.toParams());
    return response.data;
  }
  async hasBookmark(content) {
    const response = await this.get(`my/bookmark/application/${content.seq}`);
    return response.data;
  }
  async toggleBookmark(content) {
    const response = await this.put(`my/bookmark/application/${content.seq}`);
    return response.data;
  }

  async getApplcationMemo(content) {
    const response = await this.get(`my/memo/application/${content.seq}`);
    return response.data;
  }
  async getMemo(search, paginator) {
    const response = await this.get(`my/memo`, {...search, ...paginator.toParams()});
    return response.data;
  }
  async upsertMemo(memo) {
    let response = null;
    if(memo.seq) {
      response = await this.put(`my/memo/${memo.seq}`, memo);
    } else {
      response = await this.post(`my/memo`, memo);
    }
    return response.data;
  }
  async deleteMemo(memo) {
    const response = await this.delete(`my/memo/${memo.seq}`);
    return response.data;
  }
}

export default new MyService();